"use client";

import { useEffect, useState } from "react";

/**
 * Returns true when the app is running in an "insider" context:
 * - hostname contains "whv." (e.g. whv.example.com)
 * - hostname is "localhost" (local development)
 */
export function useIsInsider(): boolean {
  const [isInsider, setIsInsider] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const hostname = window.location.hostname;
    const port = window.location.port;
    const allowedDomains = [
      "holiyeah.tadesk.app",
      "exploore.tadesk.app",
      "localhost",
      "whv.tadesk.app",
      "100.86.143.120",
      "cas-mac-mini.taildef295.ts.net"
    ];
    setIsInsider(port === "5175" || allowedDomains.includes(hostname));
  }, []);

  return isInsider;
}
